<template>
    <div>
        <div class="form-horizontal" enctype="multipart/form-data" @submit.prevent="store" @keydown="form.errors.clear($event.target.name)">
            <table class="table table-striped">
                <tr>
                   <th>{{ uLang('app.name') }}</th>
                   <th>{{ uLang('app.action') }}</th>
                </tr>
                <tr v-for="type in types">
                    <td>
                        <input type="text" v-if="type.editable" class="form-control" :name="type.value" v-model="form['value'][type.id]">
                        <span v-if="!type.editable">{{ type.value }}</span>
                    </td>
                    <td>
                        <a href="#" @click.prevent="removeType(type)" class="btn btn-danger" v-if="type.deleteable" :title="uLang('app.delete_document_type')">
                            <i class="fa fa-trash"></i>
                        </a>
                    </td>
                </tr>
            </table>

            <div class="form-group">
                <div class="input-group">
                    <input type="text" class="form-control" name="new" v-model="newType" placeholder="Type hier uw nieuwe adres type" title="Voeg nieuwe adres toe">
                    <span class="input-group-btn">
                        <button type="button" class="btn btn-success" @click="addType" :disabled="form.busy">{{ uLang('app.add_address_type') }}</button>
                    </span>
                </div>
            </div>

            <div class="form-group">
                <input :disabled="form.busy" type="button" :value="uLang('app.save_setting')" @click="store()" class="btn btn-brand" />
            </div>
        </div>
    </div>
</template>

<script>
    import Form from '~/Form/Form'
    import { ErrorAlert, SuccessAlert, DestroyAlert } from '~/Swals'

    export default {
        name: 'form-setting-location_types',
        props: {
            settingId: {
                required: true,
            },
        },
        data() {
            return {
                form: new Form({
                    value: {},
                }),
                newType: '',
                types: []
            }
        },
        mounted: function () {
            this.retrieveValues();
        },
        methods: {
            async store() {
                this.form['patch']('/api/admin/settings/' + this.settingId)
                    .then(response => {
                        this.setValues(response);
                        new SuccessAlert({ text: this.uLang('app.type_successfully_updated', {type: lang('app.location_types')})}).show();
                    })
                    .catch(error => {
                        new ErrorAlert({
                            title: uLang('app.oops_something_went_wrong'),
                            text: uLang('app.all_inputs_need_to_be_filled'),
                        }).show();
                    });
            },

            setValues(data) {
                this.form.value = {};

                this.types = data;

                data.forEach(function (type){
                    if(type.editable){
                        this.value[type.id] = type.value;
                    }

                }, this.form);

            },

            async retrieveValues() {
                const { data } = await window.axios.get('/api/admin/settings/' + this.settingId + '/values');

                this.setValues(data);
            },

            addType() {
                if (this.newType === '')
                    return;

                this.types.push(
                    {
                        id: this.newType,
                        value: this.newType,
                        deleteable: 1,
                        editable: 1
                    }
                );
                this.form.value[this.newType] = this.newType;
                this.newType = '';
            },

            removeType(type) {
                new DestroyAlert({ entity: this.lang('app.location_type') }).show().then(async () => {
                    delete this.form.value[type.id];

                    //remove the type from the table
                    this.types = this.types.filter(function (current_type) {
                        return current_type.value != type.value;
                    });
                })
            }
        }
    }
</script>

<style lang="css" scoped>

</style>